import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const deleteNodepoolsTE = <E = CF.API.ApiError>(
  { userId, computeClusterId, nodepoolIds }: { userId: string; computeClusterId: string; nodepoolIds: string[] },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, { status: CF.API.Status }> =>
  fetchTE<{ status: CF.API.Status }, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${computeClusterId}/nodepools`,
      method: 'DELETE',
      body: { ids: nodepoolIds },
    },
    onRejected,
  );
